module.exports = m => (m && m.default) || m
